import { render } from "./Dmo.vue?vue&type=template&id=53775f7a&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./Dmo.vue?vue&type=script&lang=ts"
export * from "./Dmo.vue?vue&type=script&lang=ts"

import "./Dmo.vue?vue&type=style&index=0&id=53775f7a&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53775f7a"]])

export default __exports__